export class StopPointInsertFailed extends Error {}
